import { camelCase, isPlainObject, isArray } from 'lodash-unified';

const camelCaseKeys = <T>(obj: T): T | T[] => {
    if (isPlainObject(obj)) {
        return Object.entries(obj).reduce((result, [key, value]) => {
            result[camelCase(key) as keyof T] = camelCaseKeys(value);
            return result;
        }, {} as T);
    }

    if (isArray(obj)) {
        return obj.map(camelCaseKeys);
    }

    return obj;
};

export default camelCaseKeys;
